import React, {useState} from "react";
import "./AddCard.scss";


function AddCard({item,remove,add}) {

    return(
        <div className="add-card-container">
            <div className="add-card-action">
                <div className="inc-dec-sec">
                    <div className="inc-dec-btn" onClick={()=>{
                        remove(item)
                    }}>
                        <img src="/svg/decr.svg" alt=""/>
                    </div>
                    <span style={{padding:'0 4px'}}>{item.quantity}</span>
                    <div className="inc-dec-btn" onClick={()=>{
                        add(item)
                    }}>
                        <img src="/svg/incr.svg" alt=""/>
                    </div>
                </div>
            </div>
            <div className="add-card-info">
                <div className="add-card-info-label">
                    <span className="name">{item.name}</span>
                    <span className="price">{item.price} تومان </span>
                </div>
                <img src={item.image} alt=""/>
            </div>
        </div>
    )

}

export {AddCard}
